import React, { Component } from 'react'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import Service from 'src/Service';
import cloneDeep from 'lodash/cloneDeep';
import { Dialog } from 'primereact/dialog';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Authentication from '../../session/index'
import { BasicLazyParams } from 'src/Utils/constants';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';
import moment from 'moment';
import { getTimeSlotByKey, warningDailogInit } from 'src/Utils';
import { Specialization } from 'src/Utils/constants';
// import AppointmentInfo from './AppointmentInfo';
import CreateReseller from './createReseller';
import Header from '../../Header';
import Authorize, { PERMISSIONS } from '../../session/authorize';
import ServerlessService from 'src/Service/ServerlessService';
import LoadingComponent from 'src/LoadingComponent';
import CreditManagement from './addCredits';

class Reseller extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowAddTemplate: false,
            appointments: [],
            lazyParams: { ...BasicLazyParams, sortField: 'bookingSlot', sortOrder: 1 },
            globalSearch: '',
            isShowTemplate: false,
            appointment: null,
            currentFilter: 1,
            warningDialog: warningDailogInit,
        }

        this.serverlessService = new ServerlessService();
    }


    showBookAnAppointment = () => {
        this.setState({ isShowAddTemplate: true, editTemplate: false });
        // this.props.history.push('/appointment-book')

    }


    onChangeStatusType = (currentFilter) => {
        this.setState((prevState) => {
            return {

                currentFilter: currentFilter,
                lazyParams: BasicLazyParams
            }
        }, this.getAppointments);
    }


    onGlobalSearch = (e) => {
        this.setState((prevState) => {
            return {

                globalSearch: e.target.value,
                lazyParams: BasicLazyParams
            }
        }, this.getAppointments);
    }

    onPage = (event) => {

        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.getAppointments);
    }

    onSort = (event) => {

        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.getAppointments);
    }

    onFilter = (event) => {

        event['first'] = 0;
        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    filters: event.filters
                }
            };
        }, this.getAppointments);
        //  this.setState({ lazyParams: event }, this.getOrganizations);
    }



    getAppointments = () => {
        let { lazyParams, globalSearch } = this.state;

        this.setState({
            isLoading: true,
            appointments: []
        });
        const url = `/organization/resellers-all?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}${lazyParams.sortField ? `&sort=${lazyParams.sortOrder == 1 ? '' : '-'}${lazyParams.sortField}` : ''}`;
        this.serverlessService.post(url, { status: this.state.currentFilter }, true).then((res) => {


            if (res && res.status && res.res.status) {
                this.setState({
                    isLoading: false,
                    appointments: res.res.data,
                    totalRecords: res.res.totalRecords
                })

                // this.toast.show({ severity: 'success', summary: 'Success', detail: 'Templates fetched successfully.', life: 3000 });
            } else {

                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.message, life: 3000 });
            }

        }).catch(e => {
            console.log(e);
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
        })
    }

    showTemplate = (template) => {

        this.setState({
            isShowTemplate: true,
            template: template
        })
    }


    editTemplate = (template) => {
        this.setState({
            isShowAddTemplate: true,
            editTemplate: template
        })
    }

    deleteTemplate = (rowData) => {
        let data = { ...rowData }

        this.setState({
            warningDialog: {
                visible: true,
                headerMsg: 'Are you Sure?',
                message: `You want delete the template, it can't be undone once deleted`
            },
            editTemplate: data
        });

    }

    onConfirmChange = () => {
        this.setState({
            warningDialog: warningDailogInit,
            isLoading: true
        });

        const url = `/template/delete`;
        this.serverlessService.post(url, { _id: this.state.editTemplate._id }, true).then((res) => {


            if (res && res.status && res.res.status) {
                this.setState({
                    editTemplate: null,
                    isLoading: false
                }, () => {
                    this.getAppointments();
                })


                this.toast.show({ severity: 'success', summary: 'Success', detail: 'Templates deleted successfully.', life: 3000 });
            } else {

                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.message, life: 3000 });
            }

        }).catch(e => {
            console.log(e);
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
        })

    }



    actionsTemplate = (rowData) => {
        return (<>
            <div className="p-d-flex sp-mlr10 user-edit-t">
                {/* <Authorize permId={PERMISSIONS.TEMPLATES_VIEW} >
                    <span data-pr-tooltip="View Reseller" data-pr-position="bottom" className={`sp-ml10 anal${rowData._id.substr(2)}`} onClick={() => this.showTemplate(rowData)} >
                        <i className='pi pi-eye' />
                    </span>
                    <Tooltip className="table-li-tooltip2" autoHide={false} target={`.anal${rowData._id.substr(2)}`} />
                </Authorize>
             
                <Authorize permId={PERMISSIONS.TEMPLATES_DELETE} >
                    <span data-pr-tooltip="Delete Reseller" data-pr-position="bottom" className={`sp-ml10 del${rowData._id.substr(2)}`} onClick={() => { this.deleteTemplate(rowData) }}>
                        <i className='pi pi-trash' />
                    </span>
                    <Tooltip className="table-li-tooltip2" autoHide={false} target={`.del${rowData._id.substr(2)}`} />
                </Authorize> */}
                {/* <Authorize permId={PERMISSIONS.TEMPLATES_EDIT} > */}
                <span data-pr-tooltip="Edit Reseller" data-pr-position="bottom" className={`sp-ml10 edit${rowData._id.substr(2)}`} onClick={() => { this.editTemplate(rowData) }}>
                    <i className='pi pi-pencil' />
                </span>
                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.edit${rowData._id.substr(2)}`} />
                {/* </Authorize> */}

                <Authorize permId={PERMISSIONS.TEMPLATES_DELETE} >
                    <span data-pr-tooltip="Add Credits to Reseller" data-pr-position="bottom" className={`sp-ml10 cr${rowData._id.substr(2)}`} onClick={() => { this.showCreditManagement(rowData) }}>
                        <i className='pi pi-home' />
                    </span>
                    <Tooltip className="table-li-tooltip2" autoHide={false} target={`.cr${rowData._id.substr(2)}`} />
                </Authorize>

            </div>
        </>
        );
    }

    exportCSV = () => {
        this.dt.exportCSV();
    }


    onSaveTemplate = (isEdit) => {
        this.toast.show({ severity: 'success', summary: `${isEdit ? 'Added' : 'Modified'}`, detail: `Template ${isEdit ? 'Edited' : 'Created'} Succesfully.`, life: 3000 });


        this.setState({
            isShowAddTemplate: false,
            lazyParams: BasicLazyParams
        }, () => {
            this.getAppointments();
        })

    }


    componentDidMount() {


        this.getAppointments();
    }

    showCreditManagement = (editRow) => {

        this.setState({
            editSeller: editRow,
            isShowCreditsAdd: true
        });


    }


    onCreditsAdd = () => {
        this.toast.show({ severity: 'success', summary: `Credits added`, detail: `Credits added succesfully.`, life: 3000 });
        this.setState({
            isShowCreditsAdd: false,
            lazyParams: BasicLazyParams
        }, () => {
            this.getAppointments();
        })

    }

    render() {
        const { currentFilter } = this.state;

        //    console.log(this.state.appointments)
        const header = (
            <div className="table-header sp-tbl-header">
                <div className="sp-tbl-left">
                    <h2 >All Resellers</h2>
                    {/* 
                    <Button className={`sp-ml10 cont-btn ${currentFilter != 1 ? 'p-button-outlined' : ''}`} label={'Booked'} onClick={() => this.onChangeStatusType(1)} />
                    <Button className={`sp-ml10 cont-btn ${currentFilter != 2 ? 'p-button-outlined' : ''}`} label={'Visisted'} onClick={() => this.onChangeStatusType(2)} />
                    <Button className={`sp-ml10 cont-btn ${currentFilter != 3 ? 'p-button-outlined' : ''}`} label={'Cancelled'} onClick={() => this.onChangeStatusType(3)} /> */}

                    {this.state.showSearch && <InputText placeholder="Search" className="sp-tbl-search p-inputtext-md"
                        onChange={this.onGlobalSearch}
                        value={this.state.globalSearch}
                    />}
                </div>
                <div className="p-input-icon-left sp-tbl-filter">
                    <ul className="sp-tbl-li">
                        <Authorize permId={PERMISSIONS.TEMPLATES_GENERAL_SEARCH} >
                            <li><i data-pr-tooltip="Search" data-pr-position="bottom" className="pi pi-search sp-tbl-icon sp-tbl-srch" onClick={(e) => { this.setState({ showSearch: !this.state.showSearch }) }}></i></li>
                            <Tooltip className="table-li-tooltip" autoHide={false} target=".sp-tbl-srch" />
                        </Authorize>
                        {/* <li><i data-pr-tooltip="Download" data-pr-position="bottom" className="pi pi-download sp-tbl-icon sp-tbl-dwnld" onClick={this.exportCSV}></i></li>
                        <Tooltip className="table-li-tooltip" target=".sp-tbl-dwnld" /> */}
                    </ul>
                </div>
            </div>
        );


        return (<div>
            <Header>
                <div className='sp-main'>
                    <Authorize permId={PERMISSIONS.TEMPLATES_ADD} >
                        <Button label="+ Add Reseller" className='sp-m-lr10'
                            onClick={this.showBookAnAppointment} />
                    </Authorize>
                    {
                        this.state.isShowAddTemplate && <CreateReseller
                            reseller={this.state.editTemplate} onHide={() => {

                                this.setState({
                                    isShowAddTemplate: false
                                })
                            }}

                            onSave={this.onSaveTemplate}
                        />
                    }
                    <Authorize permId={PERMISSIONS.TEMPLATES_LIST} >
                        <div className="card sp-datatable sp-m30 ">
                            {/* <LazyTable ></LazyTable> */}
                            <DataTable ref={(el) => this.dt = el}
                                //  lazy
                                scrollable
                                responsiveLayout="scroll"
                                //  autoLayout={true}
                                rowHover
                                value={this.state.appointments}
                                // selection={this.state.selectedProducts}
                                // onSelectionChange={(e) => this.setState({ selectedProducts: e.value })}
                                dataKey="_id"
                                //</div>={true}
                                lazy
                                onSort={this.onSort}
                                onPage={this.onPage}
                                onFilter={this.onFilter}
                                first={this.state.lazyParams.first}
                                last={this.state.totalRecords}
                                rows={this.state.lazyParams.rows}
                                totalRecords={this.state.totalRecords}
                                paginator
                                rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 300, 500]}
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
                                globalFilter={this.state.globalFilter}
                                header={header}

                            >
                                <Column field="orgName" header="Org Name" />
                                <Column field="subDomain" header="Sub Domain"
                                    body={(rowData) => {
                                        return (<>
                                            <a className="ma-url ma-pointer"
                                                href={`https://${rowData.subDomain}.sendshortly.com`}
                                                target="_blank">{rowData.subDomain + '.sendshortly.com'}</a>
                                        </>)
                                    }}
                                />
                                <Column field="domain" header="Domain"
                                    body={(rowData) => {
                                        return (<>
                                            <a className="ma-url ma-pointer"
                                                href={rowData.domain}
                                                target="_blank">{rowData.domain}</a>
                                        </>)
                                    }}
                                />

                                <Column field="smsLimit" header="Sms Credits" />
                                <Column field="emailLimit" header="Email Credits" />
                                <Column
                                    sortabl body={this.actionsTemplate} header="Actions" ></Column>
                            </DataTable>

                        </div>
                    </Authorize>


                    <Toast ref={(el) => this.toast = el} position="bottom-right" />
                </div>

                <Dialog
                    //header={<></>}
                    draggable={false}
                    blockScroll={true}
                    closeOnEscape={true}
                    className='sp-alert-box'
                    dismissableMask={true}
                    closable={false}
                    visible={this.state.warningDialog.visible} style={{ maxWidth: '22vw', minWidth: '300px' }}
                    footer={() => {
                        return (<div>
                            <Button label="No" className='p-button-outlined' onClick={() => { this.setState({ warningDialog: warningDailogInit, editTemplate: null }) }} />
                            <Button label="Yes" className='sp-m-lr10' onClick={this.onConfirmChange} />

                        </div>)
                    }}
                    onHide={() => this.setState({ warningDialog: warningDailogInit, editTemplate: null })}>
                    <div>
                        {/* 
                        <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 382.865 348.356">
                            <g id="warning" transform="translate(0 -20.359)">
                                <path id="Path_3387" data-name="Path 3387" d="M378.275,314.472,222.781,38.439c-13.259-24.107-49.421-24.107-62.68,0L4.606,314.472c-13.259,24.107,3.616,54.242,31.34,54.242H345.73C374.659,367.509,391.534,338.58,378.275,314.472Z" transform="translate(0 0)" fill="#e24c4b" />
                                <path id="Path_3388" data-name="Path 3388" d="M197.907,63.025,353.4,339.058H42.413L197.907,63.025Z" transform="translate(-6.466 -6.505)" fill="#fff" />
                                <g id="Group_1556" data-name="Group 1556" transform="translate(166.037 154.157)">
                                    <path id="Path_3389" data-name="Path 3389" d="M196,207.155l9.643,63.885A15.681,15.681,0,0,0,221.31,284.3h0c7.232,0,14.465-6.027,15.67-13.259l9.643-63.885c2.41-15.67-9.643-28.929-25.313-28.929h0C205.639,178.225,194.79,191.484,196,207.155Z" transform="translate(-195.905 -178.226)" fill="#3f4448" />
                                    <circle id="Ellipse_49" data-name="Ellipse 49" cx="14.465" cy="14.465" r="14.465" transform="translate(10.939 119.332)" fill="#3f4448" />
                                </g>
                            </g>
                        </svg> */}

                    </div>
                    <p className='sp-alert-head'>{this.state.warningDialog.headerMsg}</p>
                    <p className='sp-alert-msg'>{this.state.warningDialog.message}</p>
                </Dialog>

                {
                    this.state.isLoading && <LoadingComponent />
                }



                {
                    this.state.isShowCreditsAdd && <CreditManagement
                        editSeller={this.state.editSeller}
                        onCreditsAdd={this.onCreditsAdd}
                        onHide={
                            () => {
                                this.setState({
                                    isShowCreditsAdd: false,
                                    editSeller: null
                                })
                            }
                        }

                    />
                }
            </Header>
        </div>
        )
    }
}






const mapStateToProps = (state) => ({
    user: state.user,
    userType: state?.user?.userType,
    authenticated: state?.user?.authenticated,
    isSessionChecked: state?.user?.isSessionChecked,
});


export default connect(mapStateToProps, {

})(Authentication(withRouter(Reseller)));
